import { useEffectOnce } from 'react-use';
import { getScrollParent } from '@/utils/dom';
import globalEvents from '@/utils/globalEvents';
import { getEditorAreaControlId } from '@/components/Editor/hooks/useEditingAreas';
import logger from '@/utils/logger';
let hasBoundScrollEvent = false;
const PREFIX = 'components: Editor: hooks: useScrollEditingAreas:'; // Creates an editing area change event handlers
// on a single parent element, so that relevant areas
// of the editor automatically scroll into view

export default function useScrollEditingAreas(params) {
  useEffectOnce(() => {
    if (hasBoundScrollEvent) {
      logger.warn(`${PREFIX} scroll editing area event already instantiated`);
    } else {
      hasBoundScrollEvent = true;
    } // Initiate scrolling to a target
    // on editing area selection changes


    const unsubscribeSelect = globalEvents.subscribe('editingareaselect', evt => {
      const detail = (evt === null || evt === void 0 ? void 0 : evt.detail) || {}; // Callback before scrolling

      typeof (params === null || params === void 0 ? void 0 : params.onBeforeScroll) === 'function' && params.onBeforeScroll(detail);
      setTimeout(() => {
        scrollToEditorSectionItem({
          sectionId: detail.sectionId,
          sectionEditingArea: detail.sectionEditingArea
        });
      }, 400);
    }); // Invoke an optional deselection callback
    // when an editing area becomes unselected

    const unsubscribeDeselect = globalEvents.subscribe('editingareadeselect', () => {
      typeof (params === null || params === void 0 ? void 0 : params.onDeselect) === 'function' && params.onDeselect();
    }); // Teardown and unsubscribe listeners

    return () => {
      unsubscribeSelect();
      unsubscribeDeselect();
      hasBoundScrollEvent = false;
    };
  });
} // Scroll to any active section item
// discoverable within the Editor form

export const scrollToEditorSectionItem = params => {
  if (typeof document === 'undefined') return;
  const {
    sectionId,
    sectionEditingArea
  } = params; // Missing necessary scroll details

  if (!sectionId || !sectionEditingArea) {
    return;
  }

  const elementId = getEditorAreaControlId({
    sectionId,
    sectionEditingArea
  });
  const element = document.querySelector(`#${elementId}`);
  const scrollParent = element && getScrollParent(element) || null;
  if (!element || !scrollParent) return;
  const elementTop = element.getBoundingClientRect().top;
  const containerTop = (scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.getBoundingClientRect().top) || 0;
  const scrollDistance = elementTop - containerTop - 100;
  scrollParent.scrollTop += scrollDistance;
};